import "./index.scss";

export const HeroPropagandaItem = ({
  title,
  description,
  iconColor = "black"
}) => {
  return (
    <div className="hero-propaganda-item">
      <h2 className={`propaganda-title icon-${iconColor}`}>{title}</h2>
      <p className="propaganda-description">{description}</p>
    </div>
  );
};
